module.exports = __webpack_public_path__ + "static/media/in-number-5.99b4db9d.png";